//src/services/adminUsers.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminUsers = () => {
  return adminApiRequest("/admin/users");
};

export const createAdminUser = (data) => {
  return adminApiRequest("/admin/users", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const deleteAdminUser = (id) => {
  return adminApiRequest(`/admin/users/${id}`, {
    method: "DELETE",
  });
};

export const toggleAdminUserStatus = (id) => {
  return adminApiRequest(`/admin/users/${id}/toggle`, {
    method: "PUT",
  });
};

